import { Switch } from '@mantine/core';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * @param {import('@mantine/core').SwitchProps} props
 */

const SwitchCustom = ({ styles = {}, checked = false,
  onChange = () => {}, defaultChecked = false,...props }) => {
  const [isCheck, setIsCheck] = useState(checked || defaultChecked);
  const defaultSwitchStyles = {
    track: {
      transition: 'background-color 1000ms ease, border-color 200ms ease',
      backgroundColor: isCheck ? '#5E811E' : '#CF212A',
      borderRadius: '100px',
      color: 'white',
      border: '1px solid transparent',
      '&[data-checked]': {
        backgroundColor: '#5E811E !important',
        borderColor: '#5E811E !important',
      },
    },

    thumb: {
      transition: 'background-color 1000ms ease',
      backgroundColor: 'white',
      borderRadius: '100px',
      '&::before': {
        backgroundColor: '#CF212A',
      },
      '[data-checked] &::before': {
        backgroundColor: '#5E811E !important',
      },
    },
  };

  return (
    <Switch
      {...props}
      defaultChecked={defaultChecked}
      onChange={(e) => {
        setIsCheck(!isCheck);
        onChange(e);
      }}
      styles={{
        ...styles,
        track: {
          ...defaultSwitchStyles.track,
          ...styles?.track
        },
        thumb: {
          ...defaultSwitchStyles.thumb,
          ...styles?.thumb
        },
      }}
    />
  );
};

export default SwitchCustom;

SwitchCustom.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  styles: PropTypes.object
};
